/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { useStaticQuery, graphql } from "gatsby"
import styled from '@emotion/styled';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import SectionHeadline from '../../../components/SectionHeadline'
import GoodsList from './GoodsList';
import RoundButton from "../../../components/RoundButton";
import { useLocalization } from 'gatsby-theme-i18n';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import AnimatedSection from '../../../components/AnimatedSection';
import CampaignSection from '../../goods/CampaignSection';

const OfficialGoodsSection = (props) => {

  const { t, currentLocaleObj, localeKey } = useLocalization();

  const data = useStaticQuery(graphql`
  query OfficialGoods {
    background : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_goodSection.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    list : allGoods(
      filter: {data: {status: {eq: "publish"}}}
      sort: {order: ASC, fields: order}
    ) {
      nodes {
        title { ...localizedContent }
        thumb {
          ...localizedImages
        }
      }
    }
  }
`);


  return (
    <SectionWrapper id="section_goods">
      
      <Content>
        <AnimatedSection>
          <SectionHeadline title={t('home.goods.title')} subtitle={t('home.goods.subtitle')} color={'#D00F31'} icon={'Market'} />
          <GoodsList list={data.list.nodes.map((item) => {
            return {
              image: getImage(item.thumb[localeKey]) ? getImage(item.thumb[localeKey]) : getImage(item.thumb[`default`]),
              alt: item.title[localeKey]
            }
          })}/>
          {/*t('goods.campaign.label') !== "" &&
            <CampaignSection type={'home'} />
          */}
          <ButtonContainer>
            <RoundButton color={"#F50057"} size={"large"} fixedwidth="true" fade to={`/${currentLocaleObj.prefix}/goods/`} css={css`
              width:448px;
              font-size: 28px;
              line-height: 32px;

              @media only screen and (max-width: ${breakpoint.smMax}){
                width:288px;
                font-size: 17px;
                line-height: 24px;
                height:48px;
              }

              @media only screen and (max-width: ${breakpoint.xsMax}){
                font-size: 14px;
                line-height: 20px;
                width: 100%;
                height:36px;
              }

            `}>{t('home.goods.button.label')}</RoundButton>
          </ButtonContainer>
          
        </AnimatedSection>
          <Background><GatsbyImage image={getImage(data.background)} alt="background" style={{ height: "100%", width: "auto" }} objectFit="contain" objectPosition="0 0"/></Background>
      </Content>
    </SectionWrapper>
  );
};


export default OfficialGoodsSection;

const SectionWrapper = styled.div`
  background:#F7F7FA;
  width:100%;
`;
const Content = styled.div`
  width:100%;
  margin:0 auto;
  position:relative;
  overflow:hidden;
  display:flex;
  justify-content:top;
  flex-direction:column;
  padding:96px 0;

  h2{padding:0;}

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 80px 80px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    min-height:0;
    padding:32px 24px;
  }
`

const Background = styled.div`
  width:908px;
  height:100%;
  position:absolute;
  top:0;
  left:0;
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:466px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:none;
  }
`

const ButtonContainer = styled.div`
  text-align:center;
  margin-bottom:
`
